import { connect } from 'react-redux';
import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';
import { toggleModal, toggleSnackBar } from 'state/callers';
import ProjectExtended from './ProjectExtended';
import { pmIntegrationSelector } from 'state/selectors/sensors-authorizations';
import _ from 'lodash';
import { myAccountSelector } from 'state/selectors/account';

const mapStateToProps = state => ({
  pmSensorAuthId: _.get(pmIntegrationSelector(state), 'id'),
  account: myAccountSelector(state)
});
const mapDispatchToProps = {
  toggleModal,
  toggleSnackBar
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorBoundary(ProjectExtended, 'ProjectExtended'));
